export default __webpack_public_path__ + "static/media/hexagon3.16fe7a57.png";